import React from 'react';
import Redux from 'spwa-ui-library/esm/redux';
import { navigate } from '@reach/router';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Button } from '@material-ui/core';
import { selectDesktop } from 'spwa-ui-library/esm/redux/store/appSlice';
import DrawerPwa from '../DrawerPwa';
import DialogBox from '../DialogBox';
// import { Badge } from '../Icons';
import css from './index.module.scss';

const ConfirmRelocateToCart = ({ isOpen = false, onClose = () => {} }) => {
  const isDesktop = Redux.useSelector(selectDesktop);
  const intl = useIntl();
  const handleNavigation = () => {
    navigate(`/${intl.locale}/cart`);
  };
  return (
    <>
      {isDesktop ? (
        <DialogBox isOpen={isOpen} onClose={onClose}>
          <Box className={css.confirmDailogContent}>
            <Content handleNavigation={handleNavigation} onCancel={onClose} />
          </Box>
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={isOpen}
          onClose={onClose}
          className={css.drawer}
        >
          <Box className={css.drawerInner}>
            <Content handleNavigation={handleNavigation} onCancel={onClose} />
          </Box>
        </DrawerPwa>
      )}
    </>
  );
};

export default ConfirmRelocateToCart;

const Content = ({ onCancel = () => {}, handleNavigation = () => {} }) => (
  <>
    {/* <Box className={css.BadgeWrapper}>
      <Badge />
    </Box> */}
    <h3>
      <FormattedMessage id="confirmRedirectTitle" />
    </h3>
    <Box className={css.buttons} onClick={onCancel}>
      <Button className={css.close}>
        <FormattedMessage id="no" />
      </Button>
      <Button variant="contained" color="primary" className={css.submit} onClick={handleNavigation}>
        <FormattedMessage id="yes" />
      </Button>
    </Box>
  </>
);

// component types
ConfirmRelocateToCart.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

Content.propTypes = {
  onCancel: PropTypes.func,
};
